import { Option } from "prelude-ts";

import {
    AnalyticsConfig,
    ApiConfig,
    AuthConfig,
    Config,
} from "./interface";

const domains = window.location.hostname.split(".");

const isRootDeploy = (domains[0] === "www" || domains.length < 2 || process.env.IS_ROOT_DEPLOY === "true") ? true : false;

const customerId = isRootDeploy ? window.location.hostname : domains[0];
const rootDomain = domains.slice(isRootDeploy ? 0 : 1).join(".");

const rootUrl = (): URL => {
    const url = new URL(window.location.href);
    url.hostname = rootDomain;

    // TODO: This is a hack to support local env. Remove when local is reconfigured to match dev and prod.
    if (url.hostname.endsWith("localhost")) {
        url.hostname = "localhost";
    }

    // <- hacks ends here

    url.pathname = "";
    url.search = "";
    return url;
};

const subdomainUrl = (subdomain: string, url: URL): URL => {
    const urln = new URL(url.href);
    urln.hostname = `${subdomain}.${urln.hostname}`;
    return urln;
};

const rootSubdomainUrl = (subdomain: string): URL => {
    return subdomainUrl(subdomain, rootUrl());
};


const api: ApiConfig = {
    messenger: {
        rest: () => {
            const urltmp = rootUrl();
            if (urltmp.hostname.endsWith("localhost")) {
                return new URL("https://data.us.textkit.io/api/rest");
            }
            if (urltmp.hostname.endsWith("textkit.statflo.com")) {
                return new URL("https://api-ui.textkit.statflo.com/api/rest");
            }
            return new URL("https://data.us.textkit.io/api/rest");

            //return rootSubdomainUrl("api-ui");

        },
        graphql: () => {
            const urltmp = rootUrl();
            if (urltmp.hostname.endsWith("localhost")) {
                return new URL("https://data.us.textkit.io/v1");
            }

            if (urltmp.hostname.includes("us.textkit.io")) {
                return new URL("https://data.us.textkit.io/v1");
            }

            if (urltmp.hostname.includes("textkit.statflo.com")) {
                return new URL("https://api-ui.textkit.statflo.com/v1");
            }

            const url = rootSubdomainUrl("api-ui");
            url.pathname = "/graphql";
            return url;
        },
        graphqlTouchless: () => {
            const urltmp = rootUrl();
            if (urltmp.hostname.endsWith("localhost") || urltmp.hostname.includes("us.textkit.io") ) {
                return new URL("https://data.us.textkit.io/v1");
            }
            if (urltmp.hostname.endsWith("textkit.statflo.com")) {
                return new URL("https://api-ui.textkit.statflo.com/v1");
            }
            

            const url = rootSubdomainUrl("api-ui");
            url.pathname = "/graphql";
            return url;
        },
        websocket: () => {
            const urltmp = rootUrl();
            if (urltmp.hostname.endsWith("localhost") || urltmp.hostname.includes("ca.textkit.io")) {
                return new URL("wss://data.us.textkit.io/v1/graphql");
            } 
            if (urltmp.hostname.includes("us.textkit.io")) {
                return new URL("wss://data.us.textkit.io/v1/graphql");
            }
            if (urltmp.hostname.includes("textkit.statflo.com")) {
                return new URL("wss://api-ui.textkit.statflo.com/v1/graphql");
            }
            if (urltmp.hostname.endsWith("messagingkit.com")) {
                return new URL("wss://data.us.textkit.io/v1/graphql");
            }

            const url = new URL("wss://data.us.textkit.io/v1/graphql");

            return url;
        },

    },
    admin: {
        graphql: () => {
            const urltmp = rootUrl();
            if (urltmp.hostname.endsWith("localhost")) {
                return new URL("https://data.us.textkit.io/v1/graphql");
            }

            const url = rootSubdomainUrl("api");
            url.pathname = "/graphql";
            return url;
        },

    },
    touchless: "https://api-aggregate.textkit.statflo.com/v1/graphql",
    touchlessVerify: "https://api-touchless.textkit.statflo.com/v1/graphql",
};

const config: Config = {
    customerId: () => customerId,
    workspaceUrl:
        (team: string): URL => {

            const url = rootUrl();
            if (url.hostname.endsWith("localhost")) {
                url.port = "3000";
            }

            return subdomainUrl(team, url);
        },
    workspaceSelectorUrl:
        (): URL => {

            const url = rootUrl();
            if (url.hostname.endsWith("localhost")) {
                //url.port = "3030";
            }
            return url;
        },

    authConfig: (): Promise<Option<AuthConfig>> => ((): Promise<Option<AuthConfig>> =>
        fetch(`${api.messenger.rest().origin}/api/rest/auth/${customerId}`)
            .then(
                async (response): Promise<Option<AuthConfig>> => {
                    const json = await response.json();
                    return Option.of({
                        graphql_uri: json.config[0].login_base_uri,
                        domain: json.config[0].login_base_uri,
                        client_id: json.config[0].login_client_id,
                        audience: json.config[0].login_audience,
                        login_redirect_uri: new URL(window.location.origin).toString(),
                        logout_redirect_uri: new URL(window.location.origin).toString(),
                    });
                },
            ).catch(
                async (): Promise<Option<AuthConfig>> => Option.none<AuthConfig>(),
            )
    )(),

    api,


    analyticsConfig:
        (): AnalyticsConfig => ({ segmentKey: Option.of("Yi9VNV3kOENvelGf4dTddfp7HRHZz7Hh") }),

};

export default config;